
export default [
  {
    path: "/futures",
    name: "hongbao",
        redirect: '/futures/red-packet',
        component: () => import('@/layout/index'),
    children: [
      {
        path: 'red-packet',
        component: () => import('@/pages/v2/hongbao/index')
      }
    ],
  },
]


// WEBPACK FOOTER //
// ./src/router/v2/hongbao/index.js